import { render } from "./EditDocuments.vue?vue&type=template&id=067d282d&scoped=true"
import script from "./EditDocuments.vue?vue&type=script&lang=js"
export * from "./EditDocuments.vue?vue&type=script&lang=js"

import "./EditDocuments.vue?vue&type=style&index=0&id=067d282d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067d282d"]])

export default __exports__